"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var aws_api_gateway_client_1 = require("aws-api-gateway-client");
var lodash_1 = require("lodash");
var promiseMemoize = require("promise-memoize");
var isBrowser = typeof window !== 'undefined';
var headers = isBrowser
    ? {}
    : {
        'Accept-Encoding': 'gzip, deflate, br',
    };
var endpointMapping = {
    test: {
        april: {
            endpoint: 'https://test-april.cruise-api.aida.de',
            apiKey: 'NZbJBcKLib96n1soRBwAB7b2Luu5JqWD4zZXkfHZ',
        },
        carol: {
            endpoint: 'https://test-carol.cruise-api.aida.de',
            apiKey: '68rzEnehNi8h3oMBCfJFi7tTrOmXXVXN7qqDzMIv',
        },
        hertha: {
            endpoint: 'https://test-hertha.cruise-api.aida.de',
            apiKey: 'dbdTy8Ssm31idfck32YDXLHD218cnWV33QDa2lo3',
        },
        iris: {
            endpoint: 'https://test-iris.cruise-api.aida.de',
            apiKey: 'Z047aaiv2O6MkPRfKBV81a24gviIAnJi2VcYrCwx',
        },
        medusa: {
            endpoint: 'https://test-medusa.cruise-api.aida.de',
            apiKey: 't2QZaiIpxSaMstfeSqbIl56GwJeRSEH11KEcnIq3',
        },
        amy: {
            endpoint: 'https://no.net',
            apiKey: 't2QZaiIpxSaMstfeSqbIl56GwJeRSEH11KEcnIq3',
        },
        carmen: {
            endpoint: 'https://test-carmen.cruise-api.aida.de',
            apiKey: 'ZGiV75aEny9fdfXbgFb0V1trulVK3MtAanNyhDjg',
        },
        vivien: {
            endpoint: 'https://test-vivien.cruise-api.aida.de',
            apiKey: 'OJ0NBELhClaIPhsMuzJ4Y5us58V9Yspc8ugcAzwI',
        },
        dharma: {
            endpoint: 'https://test-dharma.cruise-api.aida.de',
            apiKey: 'iSw1iUIrEs6pagJ7CIMiEan2b3HpeFIx9Ji9e8dY',
        },
    },
    prod: {
        april: {
            endpoint: 'https://april.cruise-api.aida.de',
            apiKey: 'Mj48LPkqyz3nFvVPzL6U3uDdktQStFTaGjBWy7Q2',
        },
        carol: {
            endpoint: 'https://carol.cruise-api.aida.de',
            apiKey: 'b5WQXyHhitakF9Ye3o0m91tUo7Te1h4e5Wro5Qa2',
        },
        hertha: {
            endpoint: 'https://hertha.cruise-api.aida.de',
            apiKey: '7YZPOAiGB12whJoKSms7v8hc7GiSo2s87EzTsOdm',
        },
        iris: {
            endpoint: 'https://iris.cruise-api.aida.de',
            apiKey: '6KhSE2GsIV4pQXM7ACYmPaNtCkQLGVWq8em2twBF',
        },
        medusa: {
            endpoint: 'https://medusa.cruise-api.aida.de',
            apiKey: '5OO4TYke0t6qGlXtj3Cyn9CcA0W49vQO6xvXf7g0',
        },
        amy: {
            endpoint: 'https://no.net',
            apiKey: 't2QZaiIpxSaMstfeSqbIl56GwJeRSEH11KEcnIq3',
        },
        carmen: {
            endpoint: 'https://carmen.cruise-api.aida.de',
            apiKey: '5Mtl0fL6RKMfZ8RuzyPC5x19byYHXnM8TNYhSiGh',
        },
        vivien: {
            endpoint: 'https://vivien.cruise-api.aida.de',
            apiKey: 'LIlhQH1TuHOkgaVhm54na6nzIhD8G1L6fkl9k4L2',
        },
        dharma: {
            endpoint: 'https://dharma.cruise-api.aida.de',
            apiKey: 'PKEloBw8079IvLakcAQrSawgL7NAbQoP6TfPIzX6',
        },
    },
};
// const stage = process.env.STAGE || 'test'
var Endpoint = /** @class */ (function () {
    function Endpoint(stage, service) {
        this.stage = stage;
        this.service = service;
        this.createClient();
    }
    // default method for the POST boilerplate
    Endpoint.prototype.invokePOST = function (params, path, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, invokePOST(this.client, params, path, body)];
            });
        });
    };
    // default method for the PUT boilerplate
    Endpoint.prototype.invokePUT = function (params, path, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, invokePUT(this.client, params, path, body)];
            });
        });
    };
    /**
     * Calls the specified http method on the service.
     * @param method http method
     * @param params http body params
     * @param path http path
     * @param query http query params
     */
    Endpoint.prototype.invoke = function (method, params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, statusCode, body;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.invokeApi(params, path, method, {
                            headers: headers,
                            queryParams: query,
                        }, {})];
                    case 1:
                        response = _b.sent();
                        _a = response.data, statusCode = _a.statusCode, body = _a.body;
                        if (!statusCode || !body) {
                            return [2 /*return*/, response.data];
                        }
                        else if (statusCode === 200) {
                            return [2 /*return*/, JSON.parse(body)];
                        }
                        else {
                            if (response.data.isError) {
                                throw Error(response.data.message);
                            }
                            else {
                                throw response.data;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // default method for the GET boilerplate
    Endpoint.prototype.invokeDELETE = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, invokeDELETE(this.client, params, path, query)];
            });
        });
    };
    // default method for the GET boilerplate
    Endpoint.prototype.invokeShortGET = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, GET_SHORT(this.client, params, path, query)];
            });
        });
    };
    // default method for the GET boilerplate
    Endpoint.prototype.invokeNoCacheGET = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, invokeGET(this.client, params, path, query)];
            });
        });
    };
    // default method for the GET boilerplate
    Endpoint.prototype.invokePermanentGET = function (params, path, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, GET_PERMANENT(this.client, params, path, query)];
            });
        });
    };
    Endpoint.prototype.createClient = function () {
        // create invoke url based on mapping and current stage
        var invokeUrl = endpointMapping[this.stage][this.service].endpoint;
        var opts = {
            region: 'eu-central-1',
            invokeUrl: invokeUrl,
            apiKey: endpointMapping[this.stage][this.service].apiKey,
        };
        if (!opts.apiKey) {
            delete opts.apiKey;
        }
        this.client = aws_api_gateway_client_1.default.newClient(opts);
    };
    return Endpoint;
}());
exports.Endpoint = Endpoint;
function invokeGET(client, params, path, query) {
    return __awaiter(this, void 0, void 0, function () {
        var sanitizedQuery, response, _a, statusCode, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sanitizedQuery = lodash_1.omitBy(query, lodash_1.isNil);
                    return [4 /*yield*/, client.invokeApi(params, path, 'GET', {
                            headers: headers,
                            queryParams: sanitizedQuery,
                        }, {})];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, body = _a.body;
                    if (!statusCode || !body) {
                        return [2 /*return*/, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2 /*return*/, JSON.parse(body)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function invokeDELETE(client, params, path, query) {
    return __awaiter(this, void 0, void 0, function () {
        var sanitizedQuery, response, _a, statusCode, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sanitizedQuery = lodash_1.omitBy(query, lodash_1.isNil);
                    return [4 /*yield*/, client.invokeApi(params, path, 'DELETE', {
                            headers: headers,
                            queryParams: sanitizedQuery,
                        }, {})];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, body = _a.body;
                    if (!statusCode || !body) {
                        return [2 /*return*/, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2 /*return*/, JSON.parse(body)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function invokePOST(client, params, path, body) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, statusCode, responseBody;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.invokeApi(params, path, 'POST', {
                        headers: headers,
                    }, body)];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, responseBody = _a.responseBody;
                    if (!statusCode || !body) {
                        return [2 /*return*/, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2 /*return*/, JSON.parse(responseBody)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function invokePUT(client, params, path, body) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, statusCode, responseBody;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.invokeApi(params, path, 'PUT', {
                        headers: headers,
                    }, body)];
                case 1:
                    response = _b.sent();
                    _a = response.data, statusCode = _a.statusCode, responseBody = _a.responseBody;
                    if (!statusCode || !body) {
                        return [2 /*return*/, response.data];
                    }
                    else if (statusCode === 200) {
                        return [2 /*return*/, JSON.parse(responseBody)];
                    }
                    else {
                        throw new Error("statusCode: " + statusCode);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
var GET_PERMANENT = promiseMemoize(invokeGET, {
    maxAge: 12 * 60 * 60 * 1000,
    resolve: 'json',
});
var GET_SHORT = promiseMemoize(invokeGET, {
    maxAge: 60 * 1000,
    resolve: 'json',
});
//# sourceMappingURL=endpoint.js.map